export enum PageSubContext {
  Homepage = 'HOME_PAGE',
  Wedding = 'WEDDING',
  Sustainability = 'SUSTAINABILITY',
  Other = 'OTHER',
}
